/**
 * Получает ID контракта из текущего роута
 */
export const getContractIdFromRoute = (route) => {
  const id = route.params?.id;

  if (!id) return null;

  return parseInt(id, 10);
};